var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-cell"},[_c('div',{staticClass:"content-cell-item flex-r-cc"},[_vm._v("\n    "+_vm._s(_vm.content)+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"line"})])
}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/components/tariff/title-type/content-cell.vue?vue&type=template&id=81dd0554
// module id = null
// module chunks = 